<template>
	<div class="mag-index-wrap">
		<div class="mag-header">
			<a href="/mag"><h2>Mag : a little thing of life</h2></a>
			<div class="mag-nav">
				<ul>
					<li v-for="item in Categories" :key="item.Code">
						<a :href="'/mag/' + item.Code">
							{{ item.Name }}
						</a>
					</li>
				</ul>
			</div>
		</div>
		<div v-if="popularList[0]" class="mag-index-content">
			<div class="popular-article">
				<div class="last">
					<a :href="'/mag/article/' + popularList[0].ID">
						<div
							class="mag-cover"
							:style="{
								backgroundImage: 'url(' + popularList[0].CoverImage + ')',
							}"
						></div>
						<div class="mag-list-info">
							<span class="post-time">{{ dateFormate(popularList[0].PostTime) }} </span>
							<h3>{{ popularList[0].Title }}</h3>
						</div>
					</a>
				</div>
				<h4>Most Popular / 熱門文章</h4>
				<ul>
					<template v-for="(item, index) in popularList">
						<li v-if="index > 0 && index < 4" :key="item.ID">
							<a :href="'/mag/article/' + item.ID">
								<div class="mag-cover" :style="{ backgroundImage: 'url(' + item.CoverImage + ')' }"></div>
								<div class="mag-list-info">
									<h3>{{ item.Title }}</h3>
								</div>
							</a>
						</li>
					</template>
				</ul>
			</div>
			<ArticleSlick
				v-for="(item, index) in Categories"
				:categoryName="item.Code"
				specifyClassName="mag-slick"
				:h4Name="item.Name"
				:key="item + index"
			/>
		</div>
		<a class="magDeco1 deco"><span></span></a>
		<a href="https://www.instagram.com/pazzo/" target="_blank" class="magDeco2 deco">
			<h6>FOLLOW US @pazzo</h6>
			<span></span>
		</a>
	</div>
</template>

<script>
import ArticleSlick from "@page/mag/components/ArticleSlick.vue";
import { dateFormate } from "@global/components/blog/ArticleTools";
import AlertDialog from "@global/helpers/alertDialog";

export default {
	name: "Mag",
	data() {
		return {
			Categories: [],
			popularList: [],
		};
	},
	created() {
		this.getCategory();
		this.getPopularList();
	},
	components: {
		ArticleSlick,
	},
	methods: {
		dateFormate(PostTime) {
			return dateFormate(PostTime);
		},
		getCategory() {
			var self = this;

			$.ajax({
				type: "GET",
				url: API_URL.ARTICLE_CATEGORY,
				dataType: "json",
				xhrFields: {
					withCredentials: true,
				},
				error: function () {
					console.log("error");
				},
				success: function (res) {
					if (res.Code === 200) {
						self.Categories = res.Response.Categories;
					} else {
						AlertDialog.alert("系統忙線中,請稍後再試", function () {
							window.location.href = "/";
						});
					}
				},
			});
		},
		getPopularList() {
			var self = this;

			$.ajax({
				type: "GET",
				url: API_URL.ARTICLE_LIST,
				data: { Category: "ALL", Limit: 5, Page: 1, Content: 0 },
				dataType: "json",
				xhrFields: {
					withCredentials: true,
				},
				error: function () {
					console.log("error");
				},
				success: function (res) {
					if (res.Code === 200) {
						self.popularList = res.Response.Data;
					} else {
						AlertDialog.alert("系統忙線中,請稍後再試", function () {
							window.location.href = "/";
						});
					}
				},
			});
		},
	},
};
</script>

<style></style>
